<template>
  <div class="list-group list-group-bordered" ref="list">
    <div class="list-group-header d-flex align-items-center"
         :class="{ 'justify-content-between': extraSmall || small, 'flex-column': extraSmall || small }"
         v-if="showHeader">
        <span :class="{ 'mb-2': extraSmall || small }">
          {{ researchers.length }} {{ researchers.length === 1 ? 'Coinvestigador' : 'Coinvestigadores' }} agregados
        </span>
      <div :class="{ 'ml-auto': !extraSmall && !small }" v-if="!readonly">
        <div class="d-inline-block">
          <button type="button"
                  class="btn btn-light" title="Invitar coinvestigadores"
                  data-toggle="modal"
                  data-target="#users-modal"
                  @click="$emit('add-researcher')">
            <i class="fas fa-user-plus mr-2"></i> Agregar coinvestigador
          </button>
          <button type="button"
                  class="btn btn-light" title="Invitar coinvestigadores"
                  data-toggle="modal"
                  data-target="#external-users-modal">
            <i class="fas fa-user-plus mr-2"></i> Agregar coinvestigador externo
          </button>
        </div>
      </div>
    </div>
    
    <div v-for="researcher in researchers"
         v-if="researchers && researchers.length"
         class="list-group-item"
         :data-id="researcher.id"
         :key="researcher.id"
         :researcher="researcher"
         :readonly="readonly"
         :show-actions="!readonly"
         @remove-researcher="researcher => $emit('remove-researcher', researcher)"
         is="researcher-list-item">
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import ResearcherListItem from './ResearcherListItem'
  
  export default {
    name: 'ResearchersList',
    components: {
      ResearcherListItem,
    },
    props: {
      researchers: {
        type: Array,
        default: () => ([]),
      },
      protocol: {
        type: Object,
        default: null,
      },
      showHeader: {
        type: Boolean,
        default: true,
      },
      showActions: {
        type: Boolean,
        default: true,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      resendingInvitation: false,
      cancelingInvitation: false,
      removingResearcher: false,
    }),
    methods: {
      ...mapActions({
        resendInvitationNotification: 'protocols/resendInvitationNotification',
        removeResearcher: 'protocols/removeResearcher',
      }),
      
      async cancelInvitation (researcher) {
        this.cancelingInvitation = true
        
        $(this.$refs.list).find(`.list-group-item[data-id="${researcher.id}"]`).css('opacity', 0.5)
        
        try {
          
          const response = await this.removeResearcher({
            protocol: researcher.pivot.protocol_id,
            researcher: researcher.id,
          })
          
          AlertManager.success(response.message)
          
        } catch (e) {
          AlertManager.error(e)
        }
        
        this.cancelingInvitation = false
        
        $(this.$refs.list).find(`.list-group-item[data-id="${researcher.id}"]`).css('opacity', 1)
      },
      async resendInvitation (researcher) {
        this.resendingInvitation = true
        
        try {
          
          const response = await this.resendInvitationNotification({
            invitation: researcher.pivot.id,
            protocol: researcher.pivot.protocol_id,
          })
          
          AlertManager.success(response.message)
        } catch (e) {
          AlertManager.error(e)
        }
        
        this.resendingInvitation = false
      },
    },
    computed: {
      extraSmall () {
        return this.$mq === 'xs'
      },
      small () {
        return this.$mq === 'sm'
      },
    },
  }
</script>
